import * as React from 'react';
import { SVGProps } from 'react';

const SvgExclamation = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.83 19.5a1.752 1.752 0 0 0 1.717-2.091 1.747 1.747 0 0 0-2.386-1.275 1.752 1.752 0 0 0-.567 2.854c.329.328.773.513 1.237.513zm-1.05-4.95a55.28 55.28 0 0 1-.57-3.92A37.463 37.463 0 0 1 10 6.57V4h3.67v2.57a40.177 40.177 0 0 1-.2 4.06c-.14 1.29-.32 2.6-.56 3.92h-2.13z" />
  </svg>
);

export default SvgExclamation;
